import version from '@/utils/version'
let skinLayout = []
if (version.isPC()) {
  skinLayout = [{
      "name": "bigPlayButton",
      "align": "cc",
      // "x": 30,
      // "y": 80
    },
    {
      "name": "errorDisplay",
      "align": "tlabs",
      "x": 0,
      "y": 0
    },
    {
      "name": "H5Loading",
      align: "cc"
    },
    {
      "name": "infoDisplay"
    },

    {
      "name": "controlBar",
      "align": "blabs",
      "x": 0,
      "y": 0,
      "children": [{
          name: "playButton",
          align: "tl",
          x: 35,
          y: 12
        }, //播放开始暂停按钮
        {
          name: "timeDisplay",
          align: "tl",
          x: 25,
          y: 5
        }, //播放视频时间
        {
          "name": "fullScreenButton", //全屏按钮
          "align": "tr",
          "x": 30,
          "y": 10
        },
        {
          "name": "volume", //音量
          "align": "tr",
          "x": 15,
          "y": 8
        },
      ],
    }
  ]
} else {
  skinLayout = [{
      "name": "bigPlayButton",
      "align": "cc",
      // "x": 30,
      // "y": 80
    },
    {
      "name": "errorDisplay",
      "align": "tlabs",
      "x": 0,
      "y": 0
    },
    {
      "name": "H5Loading",
      align: "cc"
    },
    {
      "name": "infoDisplay"
    },

    {
      "name": "controlBar",
      "align": "blabs",
      "x": 0,
      "y": 0,
      "children": [{
          name: "playButton",
          align: "tl",
          x: 35,
          y: 12
        }, //播放开始暂停按钮
        {
          name: "timeDisplay",
          align: "tl",
          x: 25,
          y: 5
        }, //播放视频时间
        {
          "name": "fullScreenButton", //全屏按钮
          "align": "tr",
          "x": 30,
          "y": 10
        },
        // {
        //   "name": "volume", //音量
        //   "align": "tr",
        //   "x": 15,
        //   "y": 8
        // },
      ],
    }
  ]
}

export default skinLayout